import classNames from 'classnames'
import React, { Component, MouseEvent } from 'react'
import { connect, MapStateToProps } from 'react-redux'

import { DispatchProp } from 'modules/store'

import * as fromCoreStore from '../../../core/store'
import { BonusPeriodInfoDto, BonusPeriodPart, isBlank, isPresent } from '../../../shared'

import { ReviewType } from '../../models'
import './bonus-period-switcher.scss'

type Props = DispatchProp & StateProps & OwnProps
type StateProps = {
  periods: BonusPeriodInfoDto[]
  activePeriod: BonusPeriodInfoDto | null
}

type OwnProps = {
  isSelectedPersonView?: boolean
  renderActiveParts?: boolean
  renderOverviewTab?: boolean
  isOverviewActive?: boolean
  activeSubperiodBonusPeriodId?: number
  activeSubperiodBonusPeriodType?: number // set optionaly from outer component which subperiod type will have priority
  onBonusPeriodChange?(bonusPeriodId: number): void
  onSubPeriodChange?(bonusPeriodType: ReviewType, bonusPeriodId: number): void
  onOverviewClick?(): void
}

type State = {
  activeSubPeriod: BonusPeriodPart
}
const mapStateToProps: MapStateToProps<StateProps, OwnProps, fromCoreStore.CoreState> = (
  state: fromCoreStore.CoreState,
  ownProps: OwnProps
) => {
  const periods = ownProps.isSelectedPersonView
    ? fromCoreStore.getUserBonusPeriods(state)
    : fromCoreStore.getBonusPeriods(state)
  const activePeriod = ownProps.isSelectedPersonView
    ? fromCoreStore.getUserActiveBonusPeriod(state)
    : fromCoreStore.getActiveBonusPeriod(state)

  return {
    periods,
    activePeriod,
  }
}

interface BonusPeriod {
  bonusPeriodId: number
  subPeriod: {
    type: number
    name: string
    isActive: boolean
  }
}

const enhance = connect(mapStateToProps)
export class BonusPeriodSwitcher extends Component<Props, State> {
  render() {
    const { renderActiveParts = false, activePeriod } = this.props

    if (isBlank(activePeriod)) return null

    return (
      <div className="bonus-period-switcher">
        {renderActiveParts ? this.renderActiveParts() : this.renderBonusPeriods()}
      </div>
    )
  }

  componentWillMount() {
    const { activePeriod } = this.props
    if (!isPresent(activePeriod)) return
    const activeSubPeriod =
      activePeriod.bonusPeriodParts.find((item) => item.isActive) ||
      (isPresent(this.props.activeSubperiodBonusPeriodType) &&
        activePeriod.bonusPeriodParts.find((item) => item.type === this.props.activeSubperiodBonusPeriodType)) ||
      activePeriod.bonusPeriodParts[0]

    if (isPresent(activeSubPeriod)) this.setState({ activeSubPeriod })
  }

  private handleBonusChange = (period: BonusPeriodInfoDto) => (e: MouseEvent<HTMLAnchorElement>) => {
    const { isSelectedPersonView = false, dispatch, onBonusPeriodChange, periods } = this.props
    isSelectedPersonView
      ? dispatch(new fromCoreStore.actions.SetSelectedUserActiveBonusPeriodAction(period, periods))
      : dispatch(new fromCoreStore.actions.SetActiveBonusPeriodAction(period, periods))

    if (isPresent(onBonusPeriodChange)) onBonusPeriodChange(period.bonusPeriodId)
  }

  private handleSubperiodChange = (subPeriod: BonusPeriodPart, bonusPeriodId: number) => (
    e: MouseEvent<HTMLAnchorElement>
  ) => {
    const { onSubPeriodChange } = this.props

    this.setState({ activeSubPeriod: subPeriod })
    if (isPresent(onSubPeriodChange)) {
      onSubPeriodChange(subPeriod.type, bonusPeriodId)
    }
  }

  private renderActiveParts = () => {
    const { periods, activeSubperiodBonusPeriodId } = this.props
    const { activeSubPeriod } = this.state

    const mql = window.matchMedia('(max-width: 576px)')

    if (mql.matches) {
      // MOBILE VIEW
      const allbonusPeriods: BonusPeriod[] = []

      periods.forEach((period) => {
        period.bonusPeriodParts.forEach((subperiod) => {
          allbonusPeriods.push({ bonusPeriodId: period.bonusPeriodId, subPeriod: subperiod })
        })
      })

      return (
        <>
          <a
            className={`bonus-period-switcher__item previous-icon ${
              allbonusPeriods[0].subPeriod.name === activeSubPeriod.name ? 'hidden' : ''
            }`}
            data-test="bonusPeriods"
            onClick={this.handlePrevPeriod(allbonusPeriods, activeSubPeriod)}
          />
          <a data-test="bonusPeriods" className="bonus-period-switcher__item" key={`p-${activeSubPeriod.name}`}>
            {activeSubPeriod.name}
          </a>
          <a
            data-test="bonusPeriods"
            className={`bonus-period-switcher__item next-icon ${
              allbonusPeriods[allbonusPeriods.length - 1].subPeriod.name === activeSubPeriod.name ? 'hidden' : ''
            }`}
            onClick={this.handleNextPeriod(allbonusPeriods, activeSubPeriod)}
          />
        </>
      )
    } else {
      // DESKTOP VIEW
      return periods.map((period) => {
        return period.bonusPeriodParts.map((subPeriod) => {
          const className = classNames('bonus-period-switcher__item', {
            'bonus-period-switcher__item--active':
              subPeriod.type === activeSubPeriod.type && period.bonusPeriodId === activeSubperiodBonusPeriodId,
          })

          return (
            <a
              className={className}
              data-test="bonusPeriods"
              key={`p-${period.bonusPeriodId}${subPeriod.type}`}
              onClick={this.handleSubperiodChange(subPeriod, period.bonusPeriodId)}
            >
              {subPeriod.name}
            </a>
          )
        })
      })
    }
  }

  private handlePrevPeriod = (allbonusPeriodsArray: BonusPeriod[], activeSubPeriod: BonusPeriodPart) => (
    e: MouseEvent<HTMLAnchorElement>
  ) => {
    const { onSubPeriodChange } = this.props

    allbonusPeriodsArray.map((bonusPeriod, index: number) => {
      if (bonusPeriod.subPeriod.name === activeSubPeriod.name) {
        this.setState({ activeSubPeriod: allbonusPeriodsArray[index - 1].subPeriod })
        if (isPresent(onSubPeriodChange)) {
          onSubPeriodChange(
            allbonusPeriodsArray[index - 1].subPeriod.type,
            allbonusPeriodsArray[index - 1].bonusPeriodId
          )
        }
      }
    })
  }

  private handleNextPeriod = (allbonusPeriodsArray: BonusPeriod[], activeSubPeriod: BonusPeriodPart) => (
    e: MouseEvent<HTMLAnchorElement>
  ) => {
    const { onSubPeriodChange } = this.props

    allbonusPeriodsArray.map((bonusPeriod, index: number) => {
      if (bonusPeriod.subPeriod.name === activeSubPeriod.name) {
        this.setState({ activeSubPeriod: allbonusPeriodsArray[index + 1].subPeriod })
        if (isPresent(onSubPeriodChange)) {
          onSubPeriodChange(
            allbonusPeriodsArray[index + 1].subPeriod.type,
            allbonusPeriodsArray[index + 1].bonusPeriodId
          )
        }
      }
    })
  }

  private renderBonusPeriods = () => {
    const { periods, activePeriod, renderOverviewTab, isOverviewActive, onOverviewClick } = this.props

    return (
      <>
        {renderOverviewTab && (
          <a
            className={classNames('bonus-period-switcher__item', 'bonus-period-switcher__item--overview', {
              'bonus-period-switcher__item--active': isOverviewActive,
            })}
            data-test="bonusPeriods"
            onClick={onOverviewClick || this.handleBonusChange(periods[periods.length - 1])}
            id="overview-tab"
          >
            Overview
          </a>
        )}
        {periods
          .slice()
          .sort((a, b) => new Date(b.validTo).getTime() - new Date(a.validTo).getTime())
          .map((period, index) => {
            const className = classNames('bonus-period-switcher__item', {
              'bonus-period-switcher__item--active':
                period.bonusPeriodId === activePeriod!.bonusPeriodId && !isOverviewActive,
            })

            return (
              <a
                className={className}
                data-test="bonusPeriods"
                key={`p-${index}`}
                onClick={this.handleBonusChange(period)}
              >
                {period.name}
              </a>
            )
          })}
      </>
    )
  }
}

export default enhance(BonusPeriodSwitcher)



// WEBPACK FOOTER //
// ./src/app/front-face/shared/bonus-period-switcher/bonus-period-switcher.tsx